export default "__VITE_ASSET__BCoL8Jy___"